PD = PD || {};
PD.trialpage = (function(trial){
    var CHECKBOX_RIGHT_TEMPLATE = '<div>'+
        '<div class="col-sm-12 cm-checkbox-wrapper-right">'+
            '<label class="control-label" for="<%=id%>"><%=label%>:</label>'+
            '<span class="checkbox-placeholder"></span>'+
            '<span class="help-placeholder"></span>'+
        '</div>'+
    '</div>';
    var TRACKING_LOAD_ACTIONS = ["Started", "E-mail registered", "Contact information registered", "Created"];

    /** Generates a checkbox from a config object, and adds it to the form */
    function generateRightCheckbox(form, cfg) {
        var checkbox = form._addField(cfg, form.fields.length);
        var $checkbox = (checkbox.$elm && checkbox.$elm.length)
            ? checkbox.$elm
            : checkbox._get$Element();
        var $wrapped = $($.tmpl(CHECKBOX_RIGHT_TEMPLATE, { id: checkbox.id, label: checkbox.label }));
        $wrapped.find(".checkbox-placeholder").replaceWith($checkbox.find(".cm-checkbox"));
        $wrapped.find(".help-placeholder").replaceWith($checkbox.find("[data-toggle=popover]"));
        return { checkbox: checkbox, $wrapped: $wrapped };
    }

    /** Binds event listeners for tracking, namely interaction with forms */
    function bindTracking() {
        for (var i = 0; i < forms.length; ++i) {
            var form = forms[i];
            var listener = (function(i){
                return function(e) {
                    // if e.which is undefined, it's caused by a programmatic setting of values
                    if (e.which === undefined) { return; }
                    if (!state.tracking.interacts[i]) {
                      state.tracking.interacts[i] = true;
                      dataLayer.push({
                        'trial' : {
                          'step' : (i+1)
                        },
                        'event' : 'TrialInteraction'
                      });
                    }
                }
            })(i);
            form.$elm.on("click", listener);
        }
    }

    // generate all data, and either show first step or load data and show the applicable one
    trial.init = function(){
        $steps = $(".step");
        $indicators = $(".indicator li");
        generateStep1();
        generateStep2();
        generateStep3();
        generateStep4();
        bindTracking();

        // remove ":" from all labels
        // doing it here is *real* ugly, but alternative would be to edit each template (system-wide)
        //   or to add a new parameter to each field (even uglier)
        $(".control-label").each(function(){
            var $this = $(this);
            if ($this.children().length) { return; }
            $this.text($this.text().replace(/:$/, ""));
        });

        $(".step-btn-back").click(function(){
            trial.goToStep(state.curStep - 1);
        });

        // try to load from URL
        var existingParams = PD.utils.getUrlParam();
        if (existingParams.hash) {
            this.load(existingParams.hash);
        } else {
            // try to load from localstorage
            PD.storage.get("trial-hash").then(function(data){
                if (data) {
                    var timeSince = Date.now() - data.time;
                    if (data.hash && timeSince < 24*60*60*1000) {
                        return trial.load(data.hash);
                    }
                }
                trial.loadFromData({});
            })["catch"](function(e){
                console.error("Failed to get trial-hash from localstorage", e);
                trial.loadFromData({});
            });
        }
    };

    trial.load = function(hash) {
        $.ajax({
            type: 'GET',
            url: '/api/trials/' + encodeURIComponent(hash),
            dataType: "json",
            contentType: "application/json",
            success: function(data, textStatus, xhr) {
                if (xhr.status === 200 && data.length > 0) {
                    PD.windows.notify.info(
                        null,
                        PD.homepage.__h("We can see that you've been here before. We have recovered your data so you can continue where you left off."),
                        {
                            actions: [{
                              text: PD.homepage.__h("Start over"),
                              click: function(){
                                delete state.hash;
                                PD.utils.clearUrlParam('hash', 'hash');
                                PD.storage.remove("trial-hash", function(){
                                    location.reload();
                                });
                              }
                            }]
                        }
                    );
                    trial.loadFromData(data[0]);
                } else {
                    trial.goToStep(0);
                }
            },
            error: function(_,e) {
                console.error("Failed while loading data from backend", e);
                if (_.responseText) {
                    let text = JSON.parse(_.responseText);
                    if (text.message) {
                        PD.windows.notify.danger(
                            PD.homepage.__h('Error!'),
                            PD.homepage.__h(text.message)
                        );
                        return;
                    }
                }
                // Error handling:
                PD.windows.notify.danger(
                    PD.homepage.__h('Error!'),
                    PD.utils.curlyFormat(
                        PD.homepage.__h('No connection to the server. Please try again or contact support at: {phone}.'),
                        { phone : supportPhone }
                    )
                );
            }
        });
    }

    trial.loadFromData = function(data) {
        $(".loading-wrapper").hide();
        // store data in our state
        state.hash = data.hash;
        // I miss Object.assign :(
        var urlParams = PD.utils.getUrlParam();
        state.values = {};
        Object.keys(data).forEach(function(k){ state.values[k] = data[k]; });
        Object.keys(urlParams).forEach(function(k){ state.values[k] = urlParams[k]; });
        delete state.values.hash;
        // Default value should be a trial with demo data
        if (state.values.demo_data === undefined) { state.values.demo_data = true; }
        if (state.values.campaign) { state.values.hasCampaign = true; }
        if (state.values.phone && state.values.phone_code) {
            state.values.phone = [state.values.phone_code, state.values.phone];
            delete state.values.phone_code;
        } else {
            delete state.values.phone_code;
            delete state.values.phone;
        }

        // then load the correct step
        var initialStep = 0;
        forms[0].setValues(state.values);
        forms[1].setValues(state.values);
        forms[2].setValues(state.values);
        forms[3].setValues(state.values);

        updateStep4();
        if (state.values.email) {
            // E-mail step filled and tracked:
            initialStep = 1;
            state.tracking.loads[0] = true;
            state.tracking.interacts[0] = true;
            state.tracking.loads[1] = true;
        }
        if (state.values.company) {
            // Contact information step filled and tracked:
            initialStep = 2;
            state.tracking.interacts[1] = true;
            state.tracking.loads[2] = true;
        }
        if (state.values.quote_count) {
            // Contact information step filled and tracked:
            initialStep = 3;
            state.tracking.interacts[2] = true;
            state.tracking.loads[3] = true;
        }
        this.goToStep(initialStep);

        // if we are asked to resend, do so
        var shouldResend = PD.utils.getUrlParam("resend");
        if (shouldResend && state.values.phone) {
            $.ajax({
                type: 'PATCH',
                url: '/api/trials/' + encodeURIComponent(state.hash) + '/~resendActivationCode',
                success: function(data, textStatus, xhr) {
                    if (xhr.status === 200) {
                        PD.windows.notify.info(
                            null,
                            PD.homepage.__h("We have resent the activation code to {0}").replace("{0}", state.values.phone[0] + " " + state.values.phone[1])
                        );
                    }
                },
                error: function(_,e) {
                    console.error("Failed while resending activation code", e);
                    if (_.responseText) {
                        let text = JSON.parse(_.responseText);
                        if (text.message) {
                            PD.windows.notify.danger(
                                PD.homepage.__h('Error!'),
                                PD.homepage.__h(text.message)
                            );
                            return;
                        }
                    }
                    // Error handling:
                    PD.windows.notify.danger(
                        PD.homepage.__h('Error!'),
                        PD.utils.curlyFormat(
                            PD.homepage.__h('No connection to the server. Please try again or contact support at: {phone}.'),
                            { phone : supportPhone }
                        )
                    );
                }
            });
        }
    }

    var $steps;
    var $indicators;
    var state = {
        curStep: -1,
        $active: null,
        hash: null,
        values: {},
        tracking: {
            loads: [],
            interacts: []
        }
    };
    var forms = [];
    trial.forms = forms;

    /** Go to a specific step, updating state and animating. Step is 0-indexed */
    var IS_IE = (
        window.navigator.userAgent.indexOf("MSIE ") > 0
        || window.navigator.userAgent.indexOf("Trident/") > 0
    );
    var ANIM_DUR = IS_IE ? 0 : 200; // IE11 has a rendering issue related to animations
    trial.goToStep = function(target) {
        if (target === state.curStep) { return; }
        // stop any animations already happening
        clearTimeout(trial.animationTimeout);
        $steps.removeClass("out-left out-right in-left in-right");

        // start animation if moving left/right
        var curStep = state.curStep;
        var $active = state.$active;
        var $newActive = $steps.eq(target);
        if ($active) {
            var direction = state.curStep < target
                ? 1 // going right (forwards)
                : -1; // going left (backwards)
            
            var applyActive = function(){
                $active.removeClass("out-left out-right active");
                $newActive.removeClass("in-right in-left");
            };
            if (ANIM_DUR) {
                $active.addClass("out-"+(direction === 1 ? "left" : "right"));
                $newActive.addClass("active in-"+(direction === 1 ? "right" : "left"));

                trial.animationTimeout = setTimeout(applyActive, ANIM_DUR);
            } else {
                $newActive.addClass("active");
                applyActive();
            }
        } else {
            $newActive.addClass("active");
        }

        // update indicator
        if (target === 0) {
            // hide everything but the first one if we go to first step
            $indicators.slice(1).addClass("hidden");
        } else {
            // otherwise unhide everything
            $indicators.removeClass("hidden");
        }
        $indicators.removeClass("disabled active")
            .slice(target + 1).addClass("disabled");
        $indicators.eq(target).addClass("active");

        // also update state
        state.$active = $newActive;
        state.curStep = target;

        // Focus the first field in the step:
        if (target !== 2) {
            $("div.step-"+(target+1)+" form input[type=text]")[0].focus();
        }

        // and send out tracking events, if this is the first time we go to this step
        if (!state.tracking.loads[target]) {
            state.tracking.loads[target] = true;
            var dataLayerObject = {
                'trial' : {
                  'status' : TRACKING_LOAD_ACTIONS[target],
                  'step' : (target+1),
                },
                'event' : 'TrialUpdated'
              };
  
              if (target === 1) {
                  dataLayerObject['trial']['email'] = state.values.email;
              }
              if (target === 2) {
                  dataLayerObject['trial']['name'] = state.values.name;
                  dataLayerObject['trial']['company'] = state.values.company;
                  dataLayerObject['trial']['phone'] = state.values.phone && state.values.phone.join ? state.values.phone.join(" ") : state.values.phone;
              }
              if (target === 3) {
                  var trackingValue = undefined;
  
                  switch(state.values.quality_estimate) {
                      case "A":
                          trackingValue = 200;
                          break;
                      case "B":
                          trackingValue = 100;
                          break;
                      case "C":
                          trackingValue = 50;
                          break;
                      case "D":
                          trackingValue = 10;
                          break;
                      case "Junk":
                          trackingValue = 0;
                          break;
                  }
                  if (trackingValue !== undefined) {
                      dataLayerObject['trial']['value'] = trackingValue;
                  }
                  dataLayerObject['trial']['quote_count'] = state.values.quote_count;
                  dataLayerObject['trial']['job_title'] = state.values.job_title;
                  dataLayerObject['trial']['software_usage'] = state.values.software_usage;
                  dataLayerObject['trial']['quality_estimate'] = state.values.quality_estimate;
  
              }
              
            dataLayer.push(dataLayerObject);
        }
    }

    /**
     * Upload data, either to the existing hash or to a new one
     * Supports only uploading a subset of keys from the data
     * This is done to avoid block on step 1 when we have e.g. an invalid phone number
     * @param {object} data The data to send
     * @param {(data: object) => void} cb Function to call with response from server
     * @param {string[]} [keys] The subset of data to send, or undefined if every key should be send
     * @param {(data: object) => void} fail Function to call with response from server
     */
    function uploadData(data, cb, keys, fail) {
        var url = state.hash
            ? "/api/trials/"+encodeURIComponent(state.hash)
            : "/api/trials";
        
        // create params to send
        var params = {};
        Object.keys(data).forEach(function(key){
            if (!keys || keys.indexOf(key) !== -1) {
                params[key] = data[key];
            }
        });

        if (params["phone"]) {
            params["phone_code"] = params["phone"][0];
            params["phone"] = params["phone"][1];
        }

        $.ajax({
            type: state.hash ? "PUT" : "POST",
            url: url,
            data: JSON.stringify(params),
            contentType: "application/json",
            dataType: "json",
            success: function(data, textStatus, xhr) {
                // If false, we're creating a trial
                let updating = !!state.hash;
                let dataOk = (updating ? (data.length > 0 && data[0].hash) : data.hash);
                if (xhr.status === 200 && dataOk) {
                    data = updating ? data[0] : data;
                    state.hash = data.hash;
                    PD.storage.set("trial-hash", { hash: state.hash, time: Date.now() });
                }

                cb(data, textStatus, xhr);

                // if at any point we find that we have already submitted this hash, don't keep running on it
                if (data.activated) {
                    PD.storage.remove("trial-hash");
                    delete state.hash;
                }
            },
            error: function(_,e) {
                console.error("Failed while uploading data", e);
                if (_.responseText) {
                    let text = JSON.parse(_.responseText);
                    let messages = Object.values(text).map(function(value) { return Array.isArray(value[0]) ? value[0] : value }).join('\n');
                    if (messages) {
                        PD.windows.notify.danger(
                            PD.homepage.__h('Error!'),
                            PD.homepage.__h(messages)
                        );
                        fail(_);
                        return;
                    }
                }
                PD.windows.notify.danger(
                    PD.homepage.__h('Error!'),
                    PD.utils.curlyFormat(
                        PD.homepage.__h('No connection to the server. Please try again or contact support at: {phone}.'),
                        { phone : supportPhone }
                    )
                );
            }
        });
    }

    function generateStep1() {
        var $placeholder = $(".step-1-placeholder");
        var form = new PD.forms.Form([
                {
                    type: "text",
                    name: "email",
                    label: PD.homepage.__h("E-mail"),
                    placeholder: false,
                    errorText: PD.homepage.__h("Please enter a valid email address"),
                    mandatory: true,
                    regex: /^[^@]+\@[^@]+\.([A-Za-z]{2,12})$/
                }
            ], function(values) {
                state.values.email = values.email;
                state.values.google_click_id = localStorage.getItem('gclids') || "[]";
                state.values.utm_tags = localStorage.getItem('utmData') || "[]";
            
                $.ajax({
                    type: "POST",
                    url: '/api/trials/~checkusername',
                    data: JSON.stringify({"username": values.email}),
                    contentType: "application/json",
                    dataType: "json",
                    success: function(data, textStatus, xhr) {
                        if (data) {
                            delete state.values.email;
                            PD.windows.notify.danger(
                                PD.homepage.__h("Error!"),
                                PD.homepage.__h("E-mail is already in use")
                            );
                            form.clearLoading();
                        } else {
                            form.getCaptchaToken(function (token) {
                                state.values.captcha = token;
                                uploadData(state.values, function(data, textStatus, xhr) {
                                    if (xhr.status === 200) {
                                        trial.goToStep(1);
                                    } else {
                                        // Error occurred:
                                        delete state.values.email;    
                                    }
                                    form.clearLoading();
                                }, ["google_click_id", "utm_tags", "email", "captcha"], function(_) {
                                    // Error occurred:
                                    delete state.values.email;
                                    form.clearLoading();
                                });
                            });
                        }
                    }
                });
                return false;
            }, {
                text: PD.homepage.__h("Get your free trial"),
                class: "primary"
            },
            { // Include captcha
                active: true,
                placement: "bottomleft",
            }
        );

        // clear mandatory indicators
        form.clearFeedback();

        form.insert($placeholder, true);
        forms[0] = form;
    }

    function generateStep2() {
        var $placeholder = $(".step-2-placeholder");
        var form = new PD.forms.Form([
                {
                    type: "text",
                    name: "name",
                    label: PD.homepage.__h("Name"),
                    placeholder: false,
                    errorText: PD.homepage.__h("Please enter your name"),
                    mandatory: true
                },
                {
                    type: "text",
                    name: "company",
                    label: PD.homepage.__h("Company"),
                    placeholder: false,
                    helpText: {
                      title: PD.homepage.__h("The name of your service company"),
                      content: PD.homepage.__h("The organisation's name can be changed at a later date.")
                    },
                    errorText: PD.homepage.__h("Please enter your organisation's name"),
                    mandatory: true
                },
                {
                    type: "phone",
                    name: "phone",
                    label: PD.homepage.__h("Phone number"),
                    countryCodes: ["+31", "+34", "+354", "+353", "+41", "+43", "+44", "+45", "+46", "+47", "+49"],
                    placeholder: false,
                    helpText: {
                      title: PD.homepage.__h("Why do we need your phone number?"),
                      content: PD.homepage.__h("When you create a trial on CleanCalculator, an activation key is sent to your mobile phone. <br> It is therefore important that you enter a number for a phone that can receive text messages and that you have within range. <br> We never share your contact information with others.<br><br>Contact support if you have a mobile phone with a phone number we do not support.")
                    },
                    inlineHelpText: PD.homepage.__h("We will send you an SMS with your activation key, make sure you have your mobile ready"),
                    mandatory: true
                }
            ], function(values) {
                state.values.name = values.name;
                state.values.company = values.company;
                state.values.phone = values.phone;
                forms[0].getCaptchaToken(function (token) {
                    state.values.captcha = token;
                    uploadData(state.values, function(data, textStatus, xhr) {
                        if (xhr.status === 200 && data.email) {
                            state.values.email = data.email;
                            trial.goToStep(2);
                        } else {
                            // Error occurred:
                            delete state.values.name;
                            delete state.values.company;
                            delete state.values.phone;
                        }
                        form.clearLoading();
                    }, ["name", "company", "phone", "captcha"], function(_) {
                        // Error occurred:
                        delete state.values.name;
                        delete state.values.company;
                        delete state.values.phone;
                        form.clearLoading();
                    });
                });
                return false;
            }, {
                text: PD.homepage.__h("Continue"),
                class: "primary"
            }
        );

        // Set default phone code:
        form.setValues({ "phone" : [ PD.homepage.getPhoneCode(), ""] });

        // clear mandatory indicators
        form.clearFeedback();

        $placeholder.replaceWith(form.$elm);
        forms[1] = form;
    }

    function generateStep3() {
        var $placeholder = $(".step-3-placeholder");
        
        var formInputs = [];
        
        formInputs.push({
            type: "select",
            name: "quote_count",
            label: PD.homepage.__h("How many quotes do you approximately make in a month?"),
            placeholder: false,
            errorText: PD.homepage.__h("Please choose a range of quotes"),
            mandatory: true,
            data: [{
                name: "0-2",
                value: "0-2",
            },{
                name: "3-5",
                value: "3-5",
            },{
                name: "6+",
                value: "6+",
            }],
            initialValue: false,
            emptyLabel: PD.homepage.__h("Choose")
        });
        formInputs.push({
            type: "select",
            name: "job_title",
            label: PD.homepage.__h("What is your job title or position in the company?"),
            placeholder: false,
            errorText: PD.homepage.__h("Please choose your job title"),
            mandatory: true,
            data: [{
                name: PD.homepage.__h("Owner"),
                value: "Ejer",
            },{
                name: PD.homepage.__h("Director"),
                value: "Direktør",
            },{
                name: PD.homepage.__h("Manager"),
                value: "Driftsleder",
            },{
                name: PD.homepage.__h("Supervisor"),
                value: "Serviceleder",
            },{
                name: PD.homepage.__h("Salesperson"),
                value: "Sælger",
            },{
                name: PD.homepage.__h("Other"),
                value: "Andet",
            }],
            initialValue: false,
            emptyLabel: PD.homepage.__h("Choose")
        });
        formInputs.push({
            type: "select",
            name: "software_usage",
            label: PD.homepage.__h("Are you currently working with a different quotation software?"),
            placeholder: false,
            errorText: PD.homepage.__h("Please choose your experience with quotation software"),
            mandatory: true,
            data: [{
                name: PD.homepage.__h("Yes, I'm working with a different software"),
                value: "Ja, jeg bruger et andet program / software",
            },{
                name: PD.homepage.__h("No, I'm using a calculator, spreadsheets or similar"),
                value: "Nej, jeg bruger lommeregner, excel eller lign.",
            },{
                name: PD.homepage.__h("This is my first time working with quotations"),
                value: "Det er første gang, jeg skal lave tilbud",
            }],
            initialValue: false,
            emptyLabel: PD.homepage.__h("Choose")
        });
        
        
        var valuesSend = ["quality_estimate", "quote_count", "job_title", "software_usage", "captcha", "fingerprint_visitor_id", "fingerprint_request_id"];
        
        var form = new PD.forms.Form(formInputs, function(values) {
                state.values.quote_count = values.quote_count;
                state.values.software_usage = values.software_usage;
                state.values.job_title = values.job_title;
                
                if (values.software_usage === "Det er første gang, jeg skal lave tilbud") {
                    state.values.quality_estimate = "D";    
                } else {
                    switch(state.values.quote_count) {
                        case '0-2':
                            state.values.quality_estimate = "C";
                            break;
                        case '3-5':
                            state.values.quality_estimate = "B";
                            break;
                        case '6+':
                            state.values.quality_estimate = "A";
                            break;
                        default:
                            // Something went wrong.
                            state.values.quality_estimate = null;
                            break;
                    }
                }

                // Make sure to always send captcha:
                forms[0].getCaptchaToken(function (token) {
                    state.values.captcha = token;
                    uploadData(state.values, function(data, textStatus, xhr) {
                        if (xhr.status === 200 & data.quality_estimate !== null) {
                            updateStep4();
                            trial.goToStep(3);
                        } else {
                            // Error occurred:
                            delete state.values.quote_count;
                            delete state.values.software_usage;
                            delete state.values.job_title;
                        }
                        form.clearLoading();
                    }, valuesSend, function(_) {
                        // Error occurred:
                        delete state.values.quote_count;
                        delete state.values.software_usage;
                        delete state.values.job_title;
                        form.clearLoading();
                    });
                });
                return false;
            }, {
                text: PD.homepage.__h("Continue"),
                class: "primary"
            }
        );
        $placeholder.replaceWith(form.$elm);
        forms[2] = form;
    }

    function generateStep4() {
        var $placeholder = $(".step-4-placeholder");
        var form = new PD.forms.Form([
                {
                    type: "static",
                    name: "username",
                    label: PD.homepage.__h("Your username"),
                },
                {
                    type: "text",
                    name: "code",
                    label: PD.homepage.__h("Activation key"),
                    placeholder: false,
                    errorText: PD.homepage.__h("Enter a valid activation key"),
                    inlineHelpText: "to-be-replaced",
                    mandatory: true,
                    regex: /^(\d{6})$/
                },
                {
                    type: "togglepassword",
                    name: "password",
                    label: PD.homepage.__h("Choose a password"),
                    placeholder: false,
                    errorText: PD.homepage.__h("Please enter a valid password"),
                    inlineHelpText: PD.homepage.__h("Minimum 6 characters"),
                    regex: /^.{6,}$/,
                    mandatory: true
                }
            ], function(values) {
                var data = {};
                data.username = values.username;
                data.activation_code = values.code;
                data.password = values.password;
                data.demo_data = values.demo_data;
                data.campaign = values.campaign;

                $.ajax({
                    type: 'PATCH',
                    url: '/api/trials/'+encodeURIComponent(state.hash) + '/~activate',
                    dataType: "json",
                    contentType: "application/json",
                    data: JSON.stringify(data),
                    success: function(data, textStatus, xhr) {
                        if (xhr.status === 200) {
                            if (typeof dataLayer !== "undefined") {
                                dataLayer.push({
                                  'trial' : {
                                    'status' : 'Activated'
                                  },
                                  'event' : 'TrialUpdated'
                                });
                            }
                            PD.storage.remove("trial-hash");
                            var loginForm = document.createElement('form');
                            loginForm.name = 'loginForm';
                            loginForm.action = '/cleancalculator/j_spring_security_check';
                            loginForm.method = 'post';
                            loginForm.target = '_self';

                            var usernameField = document.createElement('input');
                            usernameField.type = 'hidden';
                            usernameField.name = 'j_username';
                            usernameField.value = values.username;

                            var passwordField = document.createElement('input');
                            passwordField.type = 'hidden';
                            passwordField.name = 'j_password';
                            passwordField.value = values.password;
                            
                            loginForm.appendChild(usernameField);
                            loginForm.appendChild(passwordField);
                            
                            document.body.appendChild(loginForm);

                            loginForm.submit();
                        } else {
                            PD.windows.notify.danger(
                                PD.homepage.__h("Error!"),
                                PD.utils.curlyFormat(
                                    PD.homepage.__h('The system could not create the trial subscription. Please contact support at: {phone}.'),
                                    { phone : supportPhone }
                                )
                            );
                            form.clearLoading();
                        }
                    },
                    error: function(_,e) {
                        console.error("Failed while activating trial", e);
                        if (_.responseText) {
                            let text = JSON.parse(_.responseText);
                            if (text.message) {
                                PD.windows.notify.danger(
                                    PD.homepage.__h('Error!'),
                                    PD.homepage.__h(text.message)
                                );
                                form.clearLoading();
                                return;
                            }
                        }
                        // Error handling:
                        PD.windows.notify.danger(
                            PD.homepage.__h('Error!'),
                            PD.utils.curlyFormat(
                                PD.homepage.__h('No connection to the server. Please try again or contact support at: {phone}.'),
                                { phone : supportPhone }
                            )
                        );
                    }
                });
                return false;
            }, {
                text: PD.homepage.__h("Log in"),
                class: "primary"
            }
        );

        // add checkboxes
        var $submitBtn = form.$elm.children().last();
        var $checkboxFormGroup = $('<div class="form-group"></div>');
        // first demo data checkbox
        var $demoData = generateRightCheckbox(form, {
            type: "checkbox",
            name: "demo_data",
            label: PD.homepage.__h("Add demo data"),
            helpText: {
                title: PD.homepage.__h("What do you get when you decide to create trial data in the system?"),
                content: PD.homepage.__h("You get a system, where we have added customers and offers into the system.{0}Thus, it becomes easier for you to test and play around with the system, as you do not need to create a bunch of data, before you can test all the functions.")
                        .replace("{0}", '<br>')
            }
        }).$wrapped;
        $checkboxFormGroup.append($demoData);
        // then campaign code checkbox
        var campaignCheckboxResp = generateRightCheckbox(form, {
            type: "checkbox",
            name: "hasCampaign",
            checkedValue: true,
            uncheckedValue: false,
            label: PD.homepage.__h("Campaign code"),
            helpText: {
                title: PD.homepage.__h("Campaign code"),
                content: PD.homepage.__h("If you received a promotional code through one of our promotions, enter it here to get the benefits of the promotion.")
            }
        });
        var campaignCheckbox = campaignCheckboxResp.checkbox;
        var $campaignCheckbox = campaignCheckboxResp.$wrapped;
        $checkboxFormGroup.append($campaignCheckbox);
        $checkboxFormGroup.insertBefore($submitBtn);

        // then add the actual campaign input
        var campaignInput = form._addField({
            type: "text",
            name: "campaign",
            label: PD.homepage.__h("Campaign code"),
            placeholder: false
        }, form.fields.length);
        var $campaignInput = (campaignInput.$elm && campaignInput.$elm.length)
            ? campaignInput.$elm
            : campaignInput._get$Element();
        $campaignInput.insertBefore($submitBtn);

        // toggle campaign input on checkbox change
        $campaignInput.hide();
        campaignCheckbox.on("change", function(){
            var checked = campaignCheckbox.getValue();
            $campaignInput.toggle(checked);
        });

        // make text below password green when it's valid
        var passwordInput = form.fields[2];
        passwordInput.on("input", function(e){
            if (!e.target) { return; }
            var value = e.target.value;
            var isValid = passwordInput._checkValue(value);
            passwordInput.$elm.toggleClass("has-success", isValid);
        });

        // clear mandatory indicators
        form.clearFeedback();

        $placeholder.replaceWith(form.$elm);
        forms[3] = form;

        updateStep4();
    }

    function updateStep4() {
        var values = {};
        if (state.values.email) {
            values.username = state.values.email;
        }
        forms[3].setValues(values, true);
        if (state.values.phone) {
            // also update the help text of activation key to include phone number
            var codeField = forms[3].fields[1];
            codeField.$elm.find(".help-block p").text(
                PD.homepage.__h("6 digit one-time code has been sent by SMS to tel. {0}")
                    .replace("{0}", state.values.phone[0] + " " + state.values.phone[1])
            );
        }
        // and make sure the campaign is triggered in case it changed
        var hasCampaignCheckbox = forms[3].fields[3];
        hasCampaignCheckbox.trigger("change");
    }

    $(function(){
        if ($(".signup-flow-container").length) {
            trial.init();
        }
    });

    return trial;
})(PD.trialpage || {});
